<template>
  <v-card tile flat class="my-5">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="2">
          <div class="bg-kiri"></div>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h1 class="headline info--text"> 2. Seleksi Peserta </h1>
          <h3 class="black--text font-weight-regular">
            Proses Set Kriteria, Penilaian, Pemeringkatan, dan Pengajuan Proporsi
          </h3>
          <p class="body-2 mt-4 black--text">
            Anda diharuskan untuk melakukan set persentase penilaian, set kriteria tambahan (jika ada), melengkapi
            penilai semua Kepala Sekolah (jika menambahkan kriteria penilai daerah), melakukan pemeringkatan prioritas
            (jika ada Kepala Sekolah yang memiliki nilai dan peringkat yang sama), dan mengajukan persentase Proporsi
            Kepala Sekolah yang akan diterima.
          </p>
          <v-alert colored-border class="pa-2 my-2 bg-notif" color="warning" style="border-width: 0 !important;">
            <v-row no-gutters style="flex-wrap: nowrap">
              <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="max-width: 50px">
                <v-icon class="mx-2 orange--text">mdi-alert</v-icon>
              </v-col>
              <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                <p class="body-2 mb-0 black--text">
                  Jika semua data terkait persentase kriteria, penilaian, pemeringkatan, dan ajuan persentase Proporsi
                  Kepala Sekolah sudah lengkap dan sesuai, Silahkan ajuan data ke pusat untuk melanjutkan ke tahap
                  selanjutnya
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters style="flex-wrap: nowrap">
              <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="min-width: 40px; max-width: 50px">
                &nbsp;
              </v-col>
              <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                <v-btn
                  class="mt-2 white--text"
                  color="orange"
                  small
                  style="text-transform: capitalize"
                  depressed
                  :disabled="+pspPeringkat.is_lengkap_seleksi !== 1 || !$allow('psp-peringkat-seleksi.selesai')"
                  @click="onAjuan"
                >
                  <v-icon left dark>
                    mdi-send
                  </v-icon>
                  Ajukan ke Pusat
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'seleksi-content',

  computed: {
    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),
  },

  methods: {
    ...mapActions('peringkat', ['save']),

    onAjuan() {
      const msg = [
        '<p class="subtitle-1 black--text font-weight-bold">Apakah Anda yakin bahwa semua data Penilaian dan Pemeringkatan Semua Kepala Sekolah sudah benar ?</p>',
        '<p class="body-2 black--text">Proses ini akan mengkonfirmasi bahwa semua data Kepala Sekolah sudah benar dan akan ',
        'dilanjutkan pada tahap pemberian sebaran oleh pusat berdasarkan status negeri / swasta sekolah terkait <span class="red--text">(data penilaian ',
        'Kepala Sekolah akan dikunci dan tidak dapat diubah lagi pada sistem)</span>.</p>',
      ].join('');

      this.$confirm(msg, 'Kirim Data Penilaian Borang Peringkat ke Pusat').then(() => {
        this.save({ action: 'seleksi', type: 'selesai' }).then(() => {
          this.$success('Data berhasil disimpan');
          this.$emit('reload');
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
